import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import * as i18n from "../common/i18n";
import MaterialTable from 'material-table'
import { reactLocalStorage } from 'reactjs-localstorage';

import gql from 'graphql-tag';
import Message from "./Message";
import * as graphql from '../common/graphql';
import * as helper from "../common/helper";
import DateTimeDialog from './DateTimeDialog';

import moment from "moment";
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockIcon from '@material-ui/icons/Lock';
import ReloadIcon from '@material-ui/icons/Replay';


import { withIAM, isInRoles, ROLE_ADMIN, ROLE_READER, ROLE_OWNER, ROLE_ASSISTANT, ROLE_EDITOR } from "../common/iam";

const styles = theme => ({
});


const defaults = {
    id: true,
    starts: false,
    ends: false,
    valid: false,
    pageSize: 5,

};

const defaultsPropertyName = 'p71.pairingModes.defaults';

class PairingModes extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            userSettings: reactLocalStorage.getObject(defaultsPropertyName, defaults),
            unlock: false,
            dateTimeDialog: false,
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        return column;
    }

    handleLockDialogConfirm = async (ret) => {
        this.setState({ dateTimeDialog: false })

        try {
            const duration = moment(ret).unix() - moment().unix();
            const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                mutation: gql`
                    mutation unlock {
                        unlock (input: {duration: ${duration}}) {
                            id
                        }
                    }
                `,
            });

            this.tableRef.current.onQueryChange();
            this.showMessage(i18n.get("pairingModes.message.unlock.success"), "success")

        } catch (error) {
            this.showMessage(i18n.get("pairingModes.message.unlock.error"), "error", error.message)
        }
    }

    handleLockDialogCancel = async () => {
        this.setState({ dateTimeDialog: false })
    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization()}
                    columns={[
                        {
                            title: i18n.get("pairingModes.valid"),
                            field: 'valid',
                            hidden: this.default("valid"),
                            type: "boolean",
                            sorting: false,
                            filtering: false
                        },
                        {
                            title: i18n.get("pairingModes.starts"),
                            field: 'starts',
                            hidden: this.default("starts"),
                            type: "datetime",
                            filterComponent: helper.DateRangeFilter,
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("pairingModes.ends"),
                            field: 'ends',
                            hidden: this.default("ends"),
                            type: "datetime",
                            filterComponent: helper.DateRangeFilter,
                            sorting: true,
                            filtering: true
                        },
                        {
                            title: i18n.get("pairingModes.id"),
                            field: 'id',
                            hidden: this.default("id"),
                            sorting: true,
                            filtering: true
                        },
                    ]}
                    actions={isInRoles(this.props.roles, [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR, ROLE_ASSISTANT]) && this.state.unlock ? [
                        {
                            isFreeAction: true,
                            icon: () => { return <LockOpenIcon /> },
                            tooltip: i18n.get("pairingModes.unlock"),
                            onClick: async (event, rowData) => {
                                this.setState({ dateTimeDialog: true })
                            }
                        },
                        {
                            isFreeAction: true,
                            icon: () => { return <ReloadIcon /> },
                            tooltip: i18n.get("general.reload"),
                            onClick: async (event, rowData) => {
                                this.tableRef.current.onQueryChange();
                            }
                        }
                    ] : [{
                        isFreeAction: true,
                        icon: () => { return <LockIcon /> },
                        tooltip: i18n.get("pairingModes.lock"),
                        onClick: async (event, rowData) => {
                            try {
                                const result = await graphql.clientWithToken(this.props.accessToken).mutate({
                                    mutation: gql`
                                        mutation {
                                            lock {
                                                id
                                            }
                                        }
                                        `,
                                });

                                this.tableRef.current.onQueryChange();
                                this.showMessage(i18n.get("pairingModes.message.lock.success"), "success")

                            } catch (error) {
                                this.showMessage(i18n.get("pairingModes.message.lock.error"), "error", error.message)
                            }
                        }
                    },
                    {
                        isFreeAction: true,
                        icon: () => { return <ReloadIcon /> },
                        tooltip: i18n.get("general.reload"),
                        onClick: async (event, rowData) => {
                            this.tableRef.current.onQueryChange();
                        }
                    }]}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {


                                const where = helper.whereString(query['filters'], this.mapField, ["id"]);
                                let orderBy = helper.orderByString(query, this.mapField, 'ends', true);
                                if (where === "[]") {
                                    orderBy = helper.orderByString(query, this.mapField, "ends")
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        pairingModes(first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on PairingMode {
                                                    id,
                                                    starts {isoString},
                                                    ends {isoString},
                                                    valid
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });
                                const searchResult = {
                                    page: query.page,
                                    data: result.data.pairingModes.elements.map(
                                        (element) => {
                                            return {
                                                id: element.id,
                                                starts: element.starts ? moment(element.starts.isoString).toDate() : null,
                                                ends: element.ends ? moment(element.ends.isoString).toDate() : null,
                                                valid: element.valid === true
                                            };
                                        }),
                                    totalCount: result.data.pairingModes.totalCount
                                }
                                const unlocked = searchResult.data.filter(pairingMode => pairingMode.valid).length > 0;
                                this.setState({ unlock: !unlocked })
                                resolve(searchResult);
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                    title={i18n.get("pairingModes.title")}
                    options={{
                        addRowPosition: "first",
                        exportButton: false,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 500,
                        search: false,
                        columnsButton: true,
                        pageSize: this.default("pageSize")
                    }}
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />

                <DateTimeDialog
                    open={this.state.dateTimeDialog}
                    onConfirm={this.handleLockDialogConfirm}
                    onCancel={this.handleLockDialogCancel}
                    dialogTitle={`${i18n.get("pairingModes.dialog.lockDialog.title")}`}
                    dialogLabel={`${i18n.get("pairingModes.dialog.lockDialog.label")}`}
                    confirmText={`${i18n.get("pairingModes.dialog.lockDialog.confirm")}`} 
                    todayLabel={`${i18n.get("pairingModes.dialog.lockDialog.todayLabel")}`} 
                    cancelText={`${i18n.get("pairingModes.dialog.lockDialog.cancel")}`} />
            </div>
        )
    }
}

PairingModes.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(PairingModes))